const getPattern = (multipleOf) => {
  const decimals = getNumberOfDecimals(multipleOf);
  const regex = multipleOf === 1 || typeof multipleOf === "undefined" || multipleOf === null ? `^-?\\d*?$` : `^-?\\d*(\\.\\d{0,${decimals}})?$`;
  return regex;
};
const getNumberOfDecimals = (multipleOf) => {
  return String(multipleOf).split(".")?.[1]?.length || 0;
};
const getValidNumberInput = (input, multipleOf, previousValidValue, locale) => {
  if (input.trim() === "") {
    return { validInput: "", validNumber: void 0 };
  }
  const inputNumber = inputToNumber(input);
  if (isNumberInputValid(inputNumber, multipleOf) && inputNumber < Number.MAX_SAFE_INTEGER) {
    return {
      validInput: localizeNumberInput(input, locale),
      validNumber: inputNumber
    };
  }
  return previousValidValue ? {
    validInput: previousValidValue,
    validNumber: inputToNumber(previousValidValue)
  } : { validInput: "", validNumber: void 0 };
};
const inputToNumber = (input) => Number(normalizeDecimalSeparator(input));
const localizeNumberInput = (input, locale) => {
  const decimalSeparator = locale ? Intl.NumberFormat(locale).formatToParts(1.1).find((part) => part.type === "decimal")?.value : void 0;
  return decimalSeparator ? input.replace(/[.,]/, decimalSeparator) : input;
};
const isNumberInputValid = (value, multipleOf) => {
  const multipleOfRegex = getPattern(multipleOf);
  const validator = new RegExp(multipleOfRegex);
  return validator.test(`${value}`);
};
const normalizeDecimalSeparator = (value = "") => value.replace(",", ".");
const isNumberInputPossible = (value = "", multipleOf) => {
  if (multipleOf === 1 && value.indexOf(".") !== -1) {
    return false;
  } else if (value === "." || value === "-") {
    return true;
  }
  return isNumberInputValid(Number(value), multipleOf);
};
export {
  getNumberOfDecimals,
  getPattern,
  getValidNumberInput,
  isNumberInputPossible,
  isNumberInputValid,
  localizeNumberInput,
  normalizeDecimalSeparator
};
//# sourceMappingURL=numeric-input-utils.js.map
